import {
	ClassicyFileSystemEntryFileType,
	ClassicyIcons,
	type ClassicyFileSystemTree,
} from "classicy";

const NEWSPAPER_PDF_BASE_URL = "https://files.911realtime.org/pdfs/newspapers";

// Front-page PDFs uploaded to Wasabi under pdfs/newspapers/, paired with their byte size.
const NEWSPAPER_FRONT_PAGES: [originalFilename: string, displayName: string, size: number][] = [
	["Sept11.AK_ADN.pdf", "Anchorage Daily News.pdf", 112660],
	["Sept11.ARA_AH.pdf", "Al-Hayat.pdf", 89963],
	["Sept11.ARG_LN.pdf", "La Nación.pdf", 228129],
	["Sept11.AUT_DP.pdf", "Die Presse.pdf", 1056425],
	["Sept11.AZ_AR.pdf", "Arizona Republic.pdf", 818942],
	["Sept11.BRA_OE.pdf", "O Estado de S. Paulo.pdf", 220168],
	["Sept11.CA_LAT.pdf", "Los Angeles Times.pdf", 108851],
	["Sept11.CAN_NP.pdf", "National Post.pdf", 323866],
	["Sept11.CA_OT.pdf", "Oakland Tribune.pdf", 2902541],
	["Sept11.CA_SDUT.pdf", "San Diego Union-Tribune.pdf", 655648],
	["Sept11.CA_SFE.pdf", "San Francisco Examiner.pdf", 518790],
	["Sept11.CO_RMN.pdf", "Rocky Mountain News.pdf", 1658132],
	["Sept11.CT_HC.pdf", "Hartford Courant.pdf", 18116342],
	["Sept11.DC_WP.pdf", "The Washington Post.pdf", 2557198],
	["Sept11.FIN_TS.pdf", "Turun Sanomat.pdf", 606806],
	["Sept11.FL_MH.pdf", "Miami Herald.pdf", 739861],
	["Sept11.FRA_LIB.pdf", "Libération.pdf", 243845],
	["Sept11.GA_AJC.pdf", "Atlanta Journal-Constitution.pdf", 1208302],
	["Sept11.GER_SZ.pdf", "Süddeutsche Zeitung.pdf", 164252],
	["Sept11.HI_HA.pdf", "Honolulu Advertiser.pdf", 189650],
	["Sept11.IHT_.pdf", "International Herald Tribune.pdf", 157596],
	["Sept11.IL_CT.pdf", "Chicago Tribune.pdf", 319322],
	["Sept11.ISR_MDN.pdf", "Ma'ariv.pdf", 1054183],
	["Sept11.JPN_AS.pdf", "Asahi Shimbun.pdf", 1349550],
	["Sept11.KS_WE.pdf", "Wichita Eagle.pdf", 3208401],
	["Sept11.LA_TTT.pdf", "The Town Talk.pdf", 166244],
	["Sept11.LEB_AN.pdf", "An-Nahar.pdf", 857366],
	["Sept11.MD_TS.pdf", "The Baltimore Sun.pdf", 2488920],
	["Sept11.ME_PPH.pdf", "Portland Press Herald.pdf", 444809],
	["Sept11.MI_DN.pdf", "The Detroit News.pdf", 209030],
	["Sept11.MS_SH.pdf", "Sun Herald.pdf", 4308502],
	["Sept11.NE_LJS.pdf", "Lincoln Journal Star.pdf", 5694676],
	["Sept11.NV_LVRJ.pdf", "Las Vegas Review-Journal.pdf", 827080],
	["Sept11.NY_NYT.pdf", "The New York Times.pdf", 370964],
	["Sept11.NY_RDC.pdf", "Democrat and Chronicle.pdf", 1418820],
	["Sept11.NY_TU.pdf", "Times Union.pdf", 241550],
	["Sept11.OH_ABJ.pdf", "Akron Beacon Journal.pdf", 1519750],
	["Sept11.OR_SJ.pdf", "Statesman Journal.pdf", 325809],
	["Sept11.PA_PI.pdf", "Philadelphia Inquirer.pdf", 784473],
	["Sept11.PA_PTR.pdf", "Pittsburgh Tribune-Review.pdf", 152390],
	["Sept11.SC_TS.pdf", "The State.pdf", 2177783],
	["Sept11.TX_DMN.pdf", "Dallas Morning News.pdf", 473247],
	["Sept11.UK_TT.pdf", "The Times.pdf", 1093516],
	["Sept11.USAT_.pdf", "USA Today.pdf", 3016560],
	["Sept11.UT_SLT.pdf", "Salt Lake Tribune.pdf", 1649193],
	["Sept11.VA_NL.pdf", "The News Leader.pdf", 2820241],
	["Sept11.VA_RTD.pdf", "Richmond Times-Dispatch.pdf", 1005867],
	["Sept11.WA_SUN.pdf", "The Sun (Bremerton).pdf", 193618],
	["Sept11.WV_CG.pdf", "Charleston Gazette.pdf", 1998922],
];

export const newspaperEntries: ClassicyFileSystemTree = Object.fromEntries(
	NEWSPAPER_FRONT_PAGES.map(([originalFilename, displayName, size]) => [
		displayName,
		{
			_type: ClassicyFileSystemEntryFileType.Pdf,
			_mimeType: "application/pdf",
			_icon: ClassicyIcons.system.files.document,
			_url: `${NEWSPAPER_PDF_BASE_URL}/${originalFilename}`,
			_size: size,
		},
	]),
);
